import TagManager from '@sooro-io/react-gtm-module';
import { useEffect } from 'react';

import { getConfig } from 'config';

const useGTM = () => {
  const gtm = getConfig('config.siteConfig.integrations.gtm');

  useEffect(() => {
    if (gtm?.enabled && 'gtmId' in gtm) {
      TagManager.initialize({
        gtmId: gtm.gtmId,
      });
    }
  }, [gtm]);
};

export default useGTM;
